import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BokkzAlgDataService, BokkzVpbDataService, BokkzVpbLogic} from "@snelstart-ventures/fiscaal/domain-logic";


@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-belastbaarbedrag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-belastbaarbedrag.component.html',
  styleUrl: './tekst-belastbaarbedrag.component.scss',
})
export class TekstBelastbaarbedragComponent {

  constructor(
      public dataService: BokkzVpbDataService,
      public vpbService: BokkzVpbLogic,
      public algDataService: BokkzAlgDataService,
  ) {
  }

}
